export enum ButtonDefaultColors {
  BLACK = 'BLACK',
  BLUE = 'BLUE',
  WHITE = 'WHITE',
}
